import { LegacySessionEffects, SessionEffects } from './session';
import { ErrorEffects } from './error';

export const coreEffects = [SessionEffects, LegacySessionEffects, ErrorEffects];
